import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { AnnualAccountFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import * as Yup from "yup";
import { AnnualAccountRejectFormContainerProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import AnnualAccountRejectForm from "./rejectForm";
import { useAnnualAccountService } from "serviceHooks";
//#endregion

const AnnualAccountRejectFormContainer: ForwardRefRenderFunction<FormHandles, AnnualAccountRejectFormContainerProps> = (
  props,
  ref
) => {
  const annualAccountService = useAnnualAccountService();
  const validationSchema = Yup.object<AnnualAccountFormTypes.Reject>({
    message: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const handleSubmit = (values: AnnualAccountFormTypes.Reject) => {
    return annualAccountService.rejectAnnualAccountReport(props.id, values.message);
  };

  return (
    <AnnualAccountRejectForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={{}}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(AnnualAccountRejectFormContainer);
